import { createSelector } from 'reselect'

export const getEntityState = state => state.entities.trainingQuestions

export const getUiState = state => state.ui.trainingQuestions

export const getById = createSelector(getEntityState, state => state.byId)

export const getIsChanging = createSelector(getUiState, state => state.isChanging)
